import React, { useEffect, useRef, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseManagementFeeCategory.module.scss'

import IconToggle12x12 from '@Ui/images/myhouse/IconToggle12x12.svg'
import ComplexPyeongDetail from '@Types/entities/ComplexPyeongDetail'

const cx = className.bind(style)

type Props = {
  isViewModePyeong?: boolean
  pyeongNo: string
  complexPyeongDetailList: ComplexPyeongDetail[]
  onPyeongChangeButton: (pyeongNo: string) => (e: React.SyntheticEvent) => void
  onViewModeButton: (e: React.SyntheticEvent) => void
}

const MyhouseManagementFeeCategory: React.FC<Props> = ({ isViewModePyeong, pyeongNo, complexPyeongDetailList, onPyeongChangeButton, onViewModeButton }: Props) => {
  const refScrollingElement = useRef<HTMLDivElement>(null)
  const [isScrollEndLeft, setIsScrollEndLeft] = useState(true)
  const [isScrollEndRight, setIsScrollEndRight] = useState(false)

  const scrollListener = () => {
    const scrollingElement = refScrollingElement?.current
    if (!scrollingElement) {
      return
    }
    setIsScrollEndLeft(scrollingElement.scrollLeft < 10)
    setIsScrollEndRight(scrollingElement.scrollLeft + scrollingElement.offsetWidth >= scrollingElement.scrollWidth - 10)
  }
  useEffect(() => {
    const scrollingElement = refScrollingElement?.current

    scrollingElement?.addEventListener('scroll', scrollListener)
    return () => {
      scrollingElement?.removeEventListener('scroll', scrollListener)
    }
  }, [])

  useEffect(() => {
    const scrollingElement = refScrollingElement?.current

    scrollingElement?.querySelectorAll('button').forEach((item, i) => {
      if (pyeongNo === complexPyeongDetailList?.[i].pyeongNo) {
        const width = scrollingElement.getBoundingClientRect().width
        const targetX = item.offsetLeft - (width - item.getBoundingClientRect().width) / 2
        if (scrollingElement.scroll) {
          scrollingElement.scroll({
            left: targetX,
            behavior: 'smooth',
          })
          return
        }
        scrollingElement.scrollLeft = targetX
      }
    })
  }, [pyeongNo])
  return (
    // tab 요소 스크롤 가능한 경우
    <div className={cx('article', !isScrollEndLeft && 'mask_left', !isScrollEndRight && 'mask_right')}>
      <div role="tablist" className={cx('tab')} ref={refScrollingElement}>
        {complexPyeongDetailList?.map((complexPyeongDetail, index) => (
          <button
            type="button"
            key={complexPyeongDetail?.pyeongNo}
            className={cx('button_tab')}
            aria-selected={complexPyeongDetail?.pyeongNo === String(pyeongNo)}
            onClick={onPyeongChangeButton(complexPyeongDetail?.pyeongNo)}
          >
            {isViewModePyeong ? `${complexPyeongDetail.pyeongName2}평` : `${complexPyeongDetail.pyeongName}㎡`}
          </button>
        ))}
      </div>
      <button type="button" className={cx('button_toggle')} onClick={onViewModeButton}>
        <IconToggle12x12 />
        {isViewModePyeong ? '㎡' : '평'}
        <span className="blind">으로 보기</span>
      </button>
    </div>
  )
}

export default MyhouseManagementFeeCategory
